<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title class="max-width-25per pr-0">
              <v-spacer></v-spacer>
              Documents Management:
            </v-card-title>
            <v-card-text class="vh-80">
              <v-data-table
                dense
                hide-default-header
                :headers="headers"
                :items="adminDocumentsManagementItems"
                class="max-width-50vw border-thin mx-25per mt-8"
                :items-per-page="-1"
                hide-default-footer
              >
                <template v-slot:[`item.Name`]="{ item }">
                  <span class="subtitle-1"> {{ item.Name }} </span>
                </template>
                <template v-slot:[`item.Actions`]="{ item }">
                  <v-btn color="primary" outlined small @click="manageClick(item)">Manage</v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <EmployeeDocumentsTypesManager
      v-model="EmployeeDocumentsTypesDialog"
      v-if="isHRorFinancier && EmployeeDocumentsTypesDialog"
    />
    <EmployeeDocumentsManager
      v-model="EmployeeDocumentsDialog"
      v-if="isHRorFinancier && EmployeeDocumentsDialog"
      :user="user"
    />
  </div>
</template>
<script>
export default {
  name: 'AdminDocumentsManagement',
  components: {
    EmployeeDocumentsTypesManager: () => import('@/components/admin/documents/EmployeeDocumentsTypesManager.vue'),
    EmployeeDocumentsManager: () => import('@/components/admin/documents/EmployeeDocumentsManager.vue')
  },
  data () {
    return {
      rolesOfCurrentUser: [],
      headers: [
        {
          text: 'Name',
          value: 'Name',
          class: 'px-2 text-no-wrap',
          width: '90%'
        },
        {
          text: '',
          value: 'Actions',
          class: 'px-2 text-no-wrap',
          width: '10%',
          align: 'right'
        }
      ],
      adminDocumentsManagementItems: [
        { Name: 'Document Types' },
        { Name: 'Employee Documents' }
      ],
      EmployeeDocumentsTypesDialog: false,
      EmployeeDocumentsDialog: false
    }
  },
  mounted () {
    this.getRolesOfCurrentUser()
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    isHRorFinancier () {
      let res = false
      for (let i = 0; i < this.rolesOfCurrentUser.length; i++) {
        if (['HR', 'financier'].indexOf(this.rolesOfCurrentUser[i].RoleName) > -1) {
          res = true
          break
        }
      }
      return res
    }
  },
  methods: {
    getRolesOfCurrentUser () {
      this.axios.get('/api/employee_role/' + this.user.login, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.rolesOfCurrentUser = result.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    manageClick (item) {
      switch (item.Name) {
        case 'Document Types' :
          this.EmployeeDocumentsTypesDialog = true
          break
        case 'Employee Documents' :
          this.EmployeeDocumentsDialog = true
      }
    }
  }
}
</script>
<style lang="scss">
.max-width-50vw {
  max-width: 50vw;
}

.border-thin {
  border: thin solid #9e9e9e
}

.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row) {
  border-bottom: thin solid #9e9e9e
}

.mx-25per {
  margin-left: 25%;
  margin-right: 25%;
}

.vh-80 {
  height: 80vh;
}

tr {
  height: 40px !important;
}

.max-width-25per {
  max-width: 25%;
}
</style>
